import { useLocation } from 'react-router';

const useSearchParams = () => {
  const location = useLocation();
  return new URLSearchParams(location.search);
};

export default useSearchParams;
